<div class="epg" [ngClass]="{ 
  'empty' : hasLoaded && !isLoading && channels.length === 0, 
  'player': playerMode,
  'page': !playerMode,
  'loading': isLoading,
  'show-gridline': showGridline }">
  <div class="back-btn" (click)="onBack()"></div>
  <ng-container *ngIf="hasLoaded; else loading">
    <h1>{{ 'epg.programGuide' | translate }}</h1>
    <div #filtersContainer class="filters page-container horizontal-focusable-container"
    data-left="tv-menu" data-down="epg-grid-focusable-container">
    <div class="filters-item focusable-element" tabindex="0" [ngClass]="{'active': filter.active }"
      (click)="applyFilter(filter)" (focus)="centerFilterScroll()" *ngFor="let filter of epgFilters">
      <p *ngIf="filter.isToday; else dateName">{{ 'epg.today' | translate }}</p>
      <ng-template #dateName>
        <p>{{ filter.date | date: 'dd' }} {{ 'month.'+(filter.date | date: 'MMM') | translate }}</p>
      </ng-template>
    </div>
  </div>
  <div id="epgGrid" class="epg-grid-focusable-container" data-up="filters" #epgContainer
    [attr.data-selected-programid]="selectedEpgProgram?.startTimeEpoch">
            <div class="grid-channels">
              <div class="grid-cell header" [ngStyle]="{ width: intervalMins * timePixelRatio + 'vw' }">
                <div class="day">
                  {{ 'epg.allChannels' | translate }}
                </div>
              </div>
            <div class="grid-cell" tabindex="0" *ngFor="let channel of channels; let index = index"
              [ngStyle]="{ width: intervalMins * timePixelRatio + 'vw' }">
              <img [src]="channel.image" [alt]="channel.callSign" />
            </div>
            <div *ngIf="isLoading" class="grid-cell grid-loading"></div>
          </div>
          <div class="grid">
            <div class="grid-line" #gridline></div>
            <div class="dates-container">
              <div class="grid-row dates">
              <div class="grid-dot" #gridDot></div>
              <div class="grid-cell" [ngStyle]="{ width: intervalMins * timePixelRatio + 'vw' }"
                  *ngFor="let time of times">
                  <span>{{ time }}</span>
                </div>
              </div>
            </div>
            <div class="grid-programs">
              <div class="grid-row programs" *ngFor="let channel of channels; let vindex = index">
                <ng-container *ngFor="let program of channel.programs; let hIndex = index">
                  <div class="grid-cell epg-grid-focusable-element" tabindex="1" [attr.data-row]="vindex" #el
                    *ngIf="program.duration > 0" [id]="program.startTimeEpoch" [ngStyle]="{
                      width: program.duration * timePixelRatio + 'vw',
                      padding: program.duration * timePixelRatio | programPadding
                    }" attr.data-channelid="{{ channel.id }}" [ngClass]="{ 'active': program.active }"
                    (focus)="managePagination(vindex)" (click)="selectProgram(program)">
                    <span class="title">
                      <span> {{ program.name }}</span>
                    </span>
                    <span class="subtitle">{{ program.startTime }} - {{ program.endTime }}</span>
                  </div>
                </ng-container>
              </div>
              <div *ngIf="isLoading" class="grid-cell grid-loading">
                <div class="loading">
                  <div class="loading-spinner"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="not-found" *ngIf="hasLoaded && !this.isLoading && channels.length === 0">
          <div class="not-found-image"></div>
          <p class="not-found-title">{{ 'settings.favoritesEmptyTitle' | translate }}</p>
          <p class="not-found-subtitle">{{ 'settings.favoritesEmptySubtitle' | translate }}</p>
        </div>
  </ng-container>
</div>


<ng-template #loading> 
  <div class="loading-all">
    <div class="loading-spinner"></div>
  </div>
</ng-template>

<app-epg-details [program]="selectedProgram" (close)="closeDetails()" (play)="playContent($event)"></app-epg-details>